
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 112 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"path1 fill-color1",attrs:{"d":"M101.839 9.319l2.639 9.6h-5.277l2.639-9.6zm3.424-4.547h-6.905l-6.961 22.905h5.389l1.235-4.491h7.691l1.235 4.491h5.389l-7.074-22.905zm-13.305 0h-5.109l-3.874 16.393-3.93-16.393h-6.288l-3.986 16.393-3.874-16.393h-5.109l5.614 22.905h6.568l3.874-15.551 3.874 15.551h6.568l5.67-22.905zm-39.747 8.814c0 1.74-.561 2.526-2.751 2.526h-4.098V9.375h4.098c2.077 0 2.751.674 2.751 2.414v1.796zm1.235 14.091h6.119l-5.558-7.86c2.302-.954 3.312-2.863 3.312-5.726v-2.807c0-4.323-2.077-6.512-7.635-6.512H40.14v22.905h5.165v-7.13h3.032l5.109 7.13z"}}),_c('path',{staticClass:"path2 fill-color2",attrs:{"fill":"#009640","d":"M0 31.888h31.888V0H0v31.888zm20.94-17.741l-1.684 1.684 8.533 8.533-3.368 3.368-8.477-8.589-8.477 8.477-3.368-3.368 8.477-8.477-1.684-1.684v-3.312L9.713 9.6v2.751L8.534 13.53 4.38 9.376l-1.123 1.123c0-.73.168-3.2 2.133-5.109 2.246-2.189 4.435-.898 5.221-.112l4.042 4.042-1.011 1.011 2.246 2.189 2.246-2.189-1.011-1.011 4.042-4.042c.786-.842 2.975-2.133 5.221.056 1.965 1.965 2.189 4.435 2.189 5.165l-1.123-1.123-4.211 4.211-1.123-1.235V9.601l-1.179 1.179v3.368z"}})])
          )
        }
      }
    